import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'services/auth.service';
import { GlobalService } from 'services/global.service';
import { PagerService } from 'services/index';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styles: []
})
export class PaginationComponent implements OnInit {

  @Input() childPager;   // pager object
  @Input() childTotal;  // pager total items

  @Output() parentSetPage = new EventEmitter();

  constructor(
    private globalService : GlobalService,
    private router: Router,
    private authService: AuthService,
    private pagerService: PagerService,
  ) { 

  }

  ngOnInit() {
  }

  printPage() {
    return this.pagerService.printPage(this.childPager.currentPage, this.childPager.totalItems, this.childTotal);  
  }

  callParent(page, execType) {
    if (execType === 'previous') {
      if (this.childPager.currentPage === 1) return;
    } else if (execType === 'next') {
      if (this.childPager.currentPage === this.childPager.totalPages) return;
    }

    this.parentSetPage.emit(page);
  }
}



// WEBPACK FOOTER //
// ./src/app/component/elements/pagination/pagination.component.ts